import { types } from "../action-types";

const initialState = {
  loading: false,
  details: [],
  error: false,
  myMatchesLoading: false,
  matches: [],
  skillset: [],
  counts: {},
  loadmore: false
};

const getMatchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_MATCH_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_MATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
      };

    case types.GET_MATCH_FAILURE:
      return {
        ...state,
        loading: false,
        details: [],
        error: true,
      };
    case types.FIND_MATCH_REQUESTED:
      return {
        ...state,
        myMatchesLoading: true,
      };
    case types.FIND_MATCH_SUCCESS:
      if (typeof action.payload == "object") {
        return {
          ...state,
          myMatchesLoading: false,
          matches: action.payload,
          skillset: Object.entries(action.payload.other_matches),
        };
      } else {
        return {
          ...state,
        };
      }
    case types.MATCHES_RESET:
      return{
        ...state,
        matches:[],
        skillset: [],
      }
    case types.GET_MORE_MATCHES_SUCCESS:
      let tempO = state.skillset.map((res, i) => {
        if (res[0] == action.data) {
          let temp = [...res[1], ...action.payload]
          let myarr = [res[0], temp]
          return myarr
        }
        else {
          return res
        }
      })
      let allmatches = state.matches
      let myarray = state.matches;
      if (allmatches.allskills_matches.label == action.data) {
        myarray = {
          allskills_matches: {
            label: state.matches.allskills_matches.label,
            matches: [...allmatches.allskills_matches.matches, ...action.payload]
          },
          other_matches:{
            ...state.skillset
          }
        }
      }
      return {
        ...state,
        skillset: tempO,
        matches: myarray.allskills_matches.matches.length>0 ? myarray : state.matches,
        loadmore:false
      }
    case types.GET_MATCHES_COUNT_SUCCESS:
      return {
        ...state,
        counts: action.payload
      }
    case types.GET_MORE_MATCHES_INIT:
      return {
        ...state,
        loadmore: action.payload.label
      }
    case types.FIND_MATCH_FAILURE:
      return {
        ...state,
        myMatchesLoading: false,
      };

    case types.GET_SKILL_MACTHES_SUCCESS:
      return {
        ...state,
        loading: false,
        matches: action.payload,
        skillset: Object.entries(action.payload.other_matches),
        error: false,
      };

    case types.GET_MATCH_SORT:
      return {
        ...state,
        loading: true,
      };

    case types.GET_MATCH_SORT_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
      };

    case types.GET_MATCH_SORT_FAILURE:
      return {
        ...state,
        loading: false,
        details: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getMatchesReducer;
